module.exports = __webpack_public_path__ + "img/weiqu.7873504c.gif";